'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-autowhatever/dist/index.js
// module id = ./node_modules/react-autowhatever/dist/index.js
// module chunks = 2